// src/pages/Home.js
import PageLayout from "../components/PageLayout";
import SocialLink from "../components/SocialLink";
// import Storygraph from "../components/Storygraph";


const SOCIAL_LINKS = [
  { href: "https://github.com/ar1a3131",             src: "logos/github.svg",   alt: "Github",           width: "35px" },
  { href: "https://www.linkedin.com/in/arianna-azizi/", src: "logos/linkedin.svg", alt: "LinkedIn",        width: "75px" },
  { href: "https://www.instagram.com/ariaz.art/?hl=en", src: "logos/insta.png", alt: "Art Instagram"},
  { href: "https://app.thestorygraph.com/profile/ariazi", src: "logos/storygraph.svg", alt: "Storygraph", width: "45px" },
];

function Home() {
  return (
    <PageLayout title="Hi, I'm Arianna Azizi">
<div
      className="bg-white border-2 border-orange-950 p-6
                 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]
                 transition-all duration-300
                 hover:scale-[1.02] hover:shadow-[10px_10px_0px_0px_rgba(0,0,0,1)]
                 flex flex-col justify-between h-full"
    >
      <p className="text-orange-950 text-left">
        I'm currently working as an{" "}
        <strong>
          Associate Infrastructure and Automation Engineer, but I'm also
          studying for cybersecurity certifications
        </strong>
        , starting with my CompTIA Security+ certification (June 2026). I enjoy working on different projects
        outside of work. I'll be adding some of my projects on this website as
        I work on them.
        <br />
        <br />
        ...I'm always learning new things and documenting the journey...
        Outside of my 9-5 or anything SWE related, I also make art and enjoy learning foreign languages.
        <br />
        <br />
        Feel free to check out my projects, my art page, and connect with me on LinkedIn!
      </p>
</div>


      <div className="flex justify-center items-center gap-4 mt-8">
        {SOCIAL_LINKS.map(({ href, src, alt, width }) => (
          <SocialLink key={href} href={href} src={src} alt={alt} width={width} />
        ))}
      </div>

      {/* StoryGraph Reading Component */}
      {/* <section className="mt-8">
        <Storygraph />
      </section> */}
    </PageLayout>
  );
}

export default Home;